import skillSerpsData from './skills.json';

const normalizeSkill = (value: string): string => value.trim().toLowerCase();

const skillToSerpSlug = Object.entries(skillSerpsData).reduce<
  Record<string, string>
>((skillMap, [slug, skillName]) => {
  const normalizedSkillName = normalizeSkill(skillName);

  if (!skillMap[normalizedSkillName]) {
    skillMap[normalizedSkillName] = slug;
  }

  return skillMap;
}, {});

export const getSkillSerpUrl = (skill: string): string | undefined => {
  const normalizedSkill = normalizeSkill(skill);
  const slug = skillToSerpSlug[normalizedSkill];

  return slug ? `/jobs/skill/${encodeURIComponent(slug)}` : undefined;
};
